<template>
  <ContentLayout
    widthClass="max-1000"
    :title="$t('label_essweb_eventType_from_newTitle')"
    :initData="eventTypeData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'event_type_status',
      'event_type_name',
      'event_type_description',
      'event_type_abbr',
      'event_type_code',
      'table_name',
      'view_name',
      'container_name',
      'color_code',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start" class="white lighten-5">
          <!-- <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0 pb-0">
            <v-switch
              v-model="eventTypeData.event_type_status"
              class="ma-4 mt-0 mb-0"
              :label="
                eventTypeData.event_type_status
                  ? $t('label_essweb_eventType_from_activeTextLabel')
                  : ''
              "
            ></v-switch>
          </v-col> -->
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <inputTextFiledMultiLang
              ref="event_type_name"
              :bindData="eventTypeData.event_type_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  eventTypeData.event_type_name = valueArr;
                }
              "
              :label="$t('label_essweb_eventType_from_eventTypeNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <inputTextFiledMultiLang
              :bindData="eventTypeData.event_type_abbr"
              maxlength="20"
              @change="
                (valueArr) => {
                  eventTypeData.event_type_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_eventType_from_eventTypeAbbrLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_eventType_from_tagColorLabel")
            }}</v-sheet>
            <SelectColor
              :items="$Colors"
              v-model="eventTypeData.color_code"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="eventTypeData.event_type_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  eventTypeData.event_type_description = valueArr;
                }
              "
              :label="$t('label_essweb_eventType_from_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :label="$t('label_essweb_eventType_from_eventTypeCodeLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
              maxlength="100"
              v-model="eventTypeData.event_type_code"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">
              {{ $t("label_essweb_eventType_from_tableNameLabel") }}</v-sheet
            >
            <v-autocomplete
              :items="tables"
              filled
              item-text="view_fields"
              item-value="value_field"
              v-model="eventTypeData.table_name"
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              :rules="$GetRules(['_Require_Rules'], [null])"
              single-line
              :label="$t('label_essweb_eventType_from_tableNameLabel')"
              dense
            >
              <template v-slot:no-data> <noContent /> </template>
              <template v-slot:selection="data">
                {{ $getCommonLangValue(data.item.view_fields) }}
              </template>
              <template v-slot:item="data">
                <div class="table-title text--primary">
                  {{ $getCommonLangValue(data.item.view_fields) }}
                </div>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_eventType_from_viewNameLabel") }}
            </v-sheet>
            <v-autocomplete
              :items="views"
              filled
              item-text="view_fields"
              item-value="value_field"
              v-model="eventTypeData.view_name"
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              single-line
              :label="$t('label_essweb_eventType_from_viewNameLabel')"
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col> -->
          <!-- <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_eventType_from_containerLabel") }}
            </v-sheet>
            <v-autocomplete
              :items="items"
              filled
              v-model="eventTypeData.container_name"
              single-line
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              :label="$t('label_essweb_eventType_from_containerLabel')"
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_eventType_from_remarkLabel") }}
            </v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              filled
              dense
              single-line
              v-model="eventTypeData.remarks"
              counter="500"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toAdd" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newEvent",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      isChanged: false,
      eventTypeData: {
        event_type_status: false,
        event_type_name: "",
        event_type_description: "",
        event_type_abbr: "",
        event_type_code: "",
        table_name: "",
        view_name: "",
        container_name: "",
        color_code: "",
        remarks: "",
      },
      tables: [
        "ess_att_event_break",
        "ess_att_event_duty",
        "ess_att_event_meal",
      ],
      views: [],
      items: [],
    };
  },
  mounted() {
    const that = this;
    // this.eventTypeData.event_type_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.eventTypeData.event_type_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.eventTypeData.event_type_abbr = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // 获取表名
    this.$findPrompt({
      prompt_name: "ess_event_table_select",
      table_type: 1,
    }).then((res) => {
      that.tables = res.data;
    });

    // //获取表视图
    // this.$findPrompt({
    //
    //   prompt_name: "ess_table_select",
    //   table_type: 2,

    // }).then((res) => {
    //   that.views = res.data;
    // });
  },
  methods: {
    toAdd: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "event_event_type",
        url: "/event-type/add-event-type-table/",
        data: {
          // event_type_status: this.eventTypeData.event_type_status ? 1 : 0,//BJ
          event_type_name: this.$transCommonLangKey(
            this.eventTypeData.event_type_name
          ),
          event_type_description: this.$transCommonLangKey(
            this.eventTypeData.event_type_description
          ),
          event_type_abbr: this.$transCommonLangKey(
            this.eventTypeData.event_type_abbr
          ),
          event_type_code: this.eventTypeData.event_type_code,
          table_name: this.eventTypeData.table_name,
          // view_name: this.eventTypeData.view_name,
          // container_name: this.eventTypeData.container_name,
          color_code: this.eventTypeData.color_code,
          remarks: this.eventTypeData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
